export default {"src":"/_next/static/media/lazy.1fe7e117.gif","height":274,"width":480,"blurWidth":0,"blurHeight":0};